module.exports = __webpack_public_path__ + "static/media/pers-7.2ff78242.jpg";